import React from 'react';
import icon from '../assets/icons/frameMenuSmartZoneIcon.svg';
import styles from '../styles.module.css';
import { labeledMenuComponent } from '../utils/stylus';
import { svgToIcon } from '../utils/svg';
import Stylus from './Stylus';
import FrameDrawingBrush, {
  type StylusFrameOptions,
} from './FrameDrawingBrush';

export class StylusSmartZone extends Stylus {
  renderIcon() {
    // Align with the items in the frame menu that use fonts rather than svg
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: '28px' }}>
        {svgToIcon(icon)}
      </div>
    );
  }

  description() {
    return 'Smart zone';
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  activate() {
    const options: StylusFrameOptions = {
      smartZoneConfig: {
        enabled: true,
      },
    };

    const brush = new FrameDrawingBrush(this.controller.canvas, this, options);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  stylusId() {
    return `smartZone`;
  }
}
